import { OrderInfo } from './OrderInfo';
import TimelineTab from './TimelineTab/TimelineTab';

const OrderTabs = {
	OrderInfo,
	TimelineTab,
};

export default OrderTabs;
